__turbopack_context__.v({
  "active": "CollectionFilter-module-scss-module__8HAoOa__active",
  "activeCount": "CollectionFilter-module-scss-module__8HAoOa__activeCount",
  "activeIndicator": "CollectionFilter-module-scss-module__8HAoOa__activeIndicator",
  "chevron": "CollectionFilter-module-scss-module__8HAoOa__chevron",
  "collectionGrid": "CollectionFilter-module-scss-module__8HAoOa__collectionGrid",
  "collectionOption": "CollectionFilter-module-scss-module__8HAoOa__collectionOption",
  "content": "CollectionFilter-module-scss-module__8HAoOa__content",
  "count": "CollectionFilter-module-scss-module__8HAoOa__count",
  "expanded": "CollectionFilter-module-scss-module__8HAoOa__expanded",
  "facet": "CollectionFilter-module-scss-module__8HAoOa__facet",
  "hasImage": "CollectionFilter-module-scss-module__8HAoOa__hasImage",
  "header": "CollectionFilter-module-scss-module__8HAoOa__header",
  "image": "CollectionFilter-module-scss-module__8HAoOa__image",
  "imageOverlay": "CollectionFilter-module-scss-module__8HAoOa__imageOverlay",
  "imageWrapper": "CollectionFilter-module-scss-module__8HAoOa__imageWrapper",
  "label": "CollectionFilter-module-scss-module__8HAoOa__label",
  "name": "CollectionFilter-module-scss-module__8HAoOa__name",
  "withImages": "CollectionFilter-module-scss-module__8HAoOa__withImages",
});
